<template>
    <div class="program-map" :class="{ active_: active }"
         v-scrollee="{ anchor: 'top', offset: 100, once: true }"
         @scrollee="handle">
        <spot-card ref="spotCard" :spot="spot"/>
        <div class="map">
            <a :href="mapHref" target="_blank">
                <div class="map__body" ref="map" id="map"></div>
            </a>
            <p class="caption">* 지도를 클릭하면 네이버 지도로 연결됩니다.</p>
        </div>
    </div>
</template>

<script>
import anime from 'animejs'
import SpotCard from '@/components/SpotCard'

export default {
    name: 'ProgramMap',
    components: {
        SpotCard,
    },
    props: {
        container: String,
        spot: null,
    },
    computed: {
        mapHref() {
            return `https://map.naver.com/?query=${window.encodeURIComponent(this.spot.address)}`
        }
    },
    data() {
        return {
            map: null,
            marker: null,
            active: false
        }
    },
    methods: {
        initMap(options) {
            this.map = new naver.maps.Map('map', options)
            this.marker = new naver.maps.Marker({
                position: options.center,
                map: this.map
            })
        },
        async handle(e) {
            if (e.detail) {
                anime({
                    targets: this.$refs.spotCard.$el,
                    translateY: {
                        value: ['30%', 0],
                        duration: 750,
                        elasticity: 300
                    },
                    opacity: {
                        value: [0, 1],
                        easing: 'easeOutQuint',
                        duration: 350
                    }
                })
                anime({
                    targets: this.$refs.map,
                    opacity: [0, 1],
                    easing: 'easeOutQuint',
                    duration: 350,
                    delay: 350
                })
            }
        }
    },
    mounted() {
        this.initMap({
            center: { lat: this.spot.coords.latitude, lng: this.spot.coords.longitude },
            draggable: false,
            logoControl: false,
            mapDataControl: false,
            minZoom: 11,
            maxZoom: 11,
            scaleControl: false,
            scrollWheel: false
        })
    }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.map__body {
    max-width: em(400);
    height: em(180);
    margin: em(124) auto 0;
}
#map {
    opacity: 0;
}
.caption {
    font-size: em(12);
    line-height: 2;
    margin-top: .5em;
    opacity: .8;
    text-align: center;
}
.spot-card {
    width: em(335);
    margin: 0 auto;
    opacity: 0;
    position: absolute;
    top: em(68);
    right: 0;
    left: 0;
    z-index: 1;
}
</style>